import React, { Component, PropTypes } from 'react';
import {Link} from 'react-router';
import { connect } from 'react-redux';
import {GetAdmin, DelAdmin, GetAdminOne, ToggleAdmin} from '../../actions/index';

class Admins extends Component {
    static contextTypes = {
        router: PropTypes.object
    };
    constructor(props){
        super(props);
        this.renderTable = this.renderTable.bind(this);
        this.editAdmin = this.editAdmin.bind(this);
        this.toggleAdmin = this.toggleAdmin.bind(this);
        this.addAdmin = this.addAdmin.bind(this);
        this.delAdminOpenModal = this.delAdminOpenModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.delAdmin = this.delAdmin.bind(this);
    }
    componentWillMount(){
        let token = localStorage.getItem('id_token_admin');
        this.props.GetAdmin(token);
    }
    editAdmin(id, item){
        this.context.router.push('/admins/edit/'+id);
    }
    toggleAdmin(id) {
        let admin = this.props.admins.list.results.filter((item) => item.id == id);
        if (admin.length !== 1) {
            return false;
        }

        admin = admin[0];

        let confirmMessage = `Please confirm you want to ${admin.is_active ? 'DEACTIVATE' : 'ACTIVATE'} ${admin.first_name} ${admin.last_name}?`;
        if (admin.is_active) {
            confirmMessage += ' This will terminate admin\'s current session';
        }

        const shouldProceed = confirm(confirmMessage);
        if (!shouldProceed) {
            return false;
        }

        const token = localStorage.getItem('id_token_admin');
        this.props.ToggleAdmin(id, {
            is_active: !admin.is_active
        }, token).then((response) => {
            window.location.reload();
        });

    }
    addAdmin(){
        this.context.router.push('/admins/add');
    }
    delAdmin(){
        let token = localStorage.getItem('id_token_admin');
        this.props.DelAdmin(this.props.admins.admin_one.id, token).then((response)=>{
            if(response.payload.status == 204){
                this.closeModal();
                this.props.GetAdmin(token);
            }
        });
    }
    delAdminOpenModal(id, item){
        let token = localStorage.getItem('id_token_admin');
        let that= this;
        $('#DelAdmin').modal('show');
        $('#DelAdmin').on('shown.bs.modal', function () {
            that.props.GetAdminOne(id, token);
        });
    }
    closeModal(){
        $('#DelAdmin').modal('hide');
        this.props.admins.admin_one = {};
    }
    renderTable(){
        return this.props.admins.list.results.map((item, i)=>{
            return(
                <div key={item.id} className="white-block common-list four clearfix">
                    <p>{i+1}</p>
                    <p>
                        <button type="button" onClick={this.toggleAdmin.bind(this, item.id)}><span className={"span glyphicon glyphicon-" + (item.is_active ? 'ok' : 'remove') + "-sign"} aria-hidden="true" /></button>
                        <span className="link-span" onClick={this.editAdmin.bind(this, item.id)}>{item.first_name} {item.last_name}</span>
                    </p>
                    <p>{item.email}</p>
                    <p>
                        <button type="button" onClick={this.editAdmin.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-edit" aria-hidden="true" />
                        </button>
                        <button type="button" onClick={this.delAdminOpenModal.bind(this, item.id)}>
                            <span className="span glyphicon glyphicon-trash" />
                        </button>
                    </p>
                </div>
            )
        })
    }
    render() {
        return (
            <div className="dashboard-wrapper">
                <div className="dashboard-title clearfix"><p className="pull-left">Admins</p>
                    <button onClick={this.addAdmin} type="button" className="pull-right btn btn-primary">
                        <span className="glyphicon glyphicon-plus" aria-hidden="true" />
                        Add admin
                    </button>
                </div>

                <div>
                    {this.props.admins.list.results && this.props.admins.list.results.length > 0 ?
                        <div>
                            <div className="col-md-12">
                                <div className="common-list four clearfix">
                                    <p>#</p>
                                    <p>Name</p>
                                    <p>Email</p>
                                    <p>Option</p>
                                </div>
                            </div>
                            <div className="col-md-12">
                                {this.renderTable()}
                            </div>
                        </div>
                        :
                        <div className={this.props.admins.list.results && this.props.admins.list.results.length < 0 || $.isEmptyObject(this.props.admins.list) ? "for_preloader" : 'for_preloader dn'}>
                            <div className="preloader-wrapper big active">
                                <div className="spinner-layer spinner-blue-only">
                                    <div className="circle-clipper left">
                                        <div className="circle" />
                                    </div>
                                    <div className="gap-patch">
                                        <div className="circle" />
                                    </div>
                                    <div className="circle-clipper right">
                                        <div className="circle" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {this.props.admins.list.results && this.props.admins.list.results === 0 && <p className="noResults">No items result</p>}

                    <div className="modal fade" id="DelAdmin" tabIndex="-1" role="dialog" aria-labelledby="DelAdminLabel">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <button type="button" className="close" onClick={this.closeModal} aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                </div>
                                <div className="modal-body text-center">
                                    <span className="glyphicon glyphicon-alert" aria-hidden="true" data-toggle="modal" data-target="#DelAdmin" />
                                    <p>Do you really want to delete admin {this.props.admins.admin_one ? <span>{this.props.admins.admin_one.first_name} {this.props.admins.admin_one.last_name}</span> : ""}?</p>
                                </div>
                                <div className="modal-footer text-center">
                                    <button onClick={this.closeModal} type="button" className="btn btn-default">No</button>
                                    <button onClick={this.delAdmin} type="button" className="btn btn-primary">Yes</button>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
                <div className="clearfix"></div>
            </div>
        );
    }
}

function  mapStateToProps(state) {
    return{
        admins: state.admins
    }
}
export default connect(mapStateToProps, {GetAdmin, DelAdmin, GetAdminOne, ToggleAdmin})(Admins);



// WEBPACK FOOTER //
// ./src/components/admin/admins.js